import {maxLength, minValue, maxValue, required, requiredIf} from 'vuelidate/lib/validators';
import {
  NEW_USED_LIST, MAX_CAR_PRICE, MAX_ODOMETER,
  UPLOAD_QUOTE_MIN_CAR_COST,
  MIN_ODOMETER, REGISTRATION_NUMBER_MAX_LENGTH
} from '../../utils/constants';

function displayUsedCarFields() {
  return this.customerOptions.vehicleCondition === NEW_USED_LIST.used.value;
}

function hasValidCarPrice(value) {
  return (
    value >= UPLOAD_QUOTE_MIN_CAR_COST[this.customerOptions.vehicleCondition]
  );
}

export default {
  customerOptions: {
    registrationNumber: {
      required: requiredIf(displayUsedCarFields),
      maxLength: maxLength(REGISTRATION_NUMBER_MAX_LENGTH)
    },
    odometer: {
      required: requiredIf(displayUsedCarFields),
      minValue: minValue(MIN_ODOMETER),
      maxValue: maxValue(MAX_ODOMETER)
    },
    carPrice: {
      required,
      minValue: hasValidCarPrice,
      maxValue: maxValue(MAX_CAR_PRICE)
    }
  },
  registrationNumber: ['customerOptions.registrationNumber'],
  odometer: ['customerOptions.odometer'],
  carPrice: ['customerOptions.carPrice']
};
